export enum Species {
  Canine = 'Canine',
  Feline = 'Feline',
  Avian = 'Avian',
  Equine = 'Equine',
  Bovine = 'Bovine',
  Other = 'Other',
}
